import React, { createContext, ReactNode, useEffect } from 'react';
import store from '../store';
import { notification } from 'antd';
import notificationStore from '../notificationStore';

export const StoreContext = createContext(store);

export const StoreProvider = ({ children }: { children: ReactNode }) => {
  const [api, contextHolder] = notification.useNotification({
    placement: 'bottomLeft',
    duration: 3,
    maxCount: 5,
  });

  useEffect(() => {
    notificationStore.initNotifications(api);
  }, [api]);

  if (process.env.NODE_ENV === 'development') {
    (window as any).rootStore = store;
  }

  return (
    <StoreContext.Provider value={store}>
      {contextHolder}
      {children}
    </StoreContext.Provider>
  );
};
